import ApiBack from "../../../../utils/domains/ApiBack";
import Municipio from "../../../../models/municipio";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import ServicePrivate from "../../../../services/ServicePrivate";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { MessageToastify } from "../../../../utils/funtions/MessageToastify";
import { useForm } from "../../../../utils/hooks/useForm";
import { useRef } from "react";
import Pacts from "../../../../models/Pacts";
import { formatDate } from "../../../../utils/funtions/date";
import { formatCurrency } from "../../../../utils/funtions/format";

export const ViewConPacts = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [process, setProcess] = useState<boolean>(false);
    const [arrayPacts, setArrayPacts] = useState<Pacts[]>([]);
    const [show, setShow] = useState(false);
    const [showData, setShowData] = useState(false);
    const [show2, setShow2] = useState(false);
    type formaHtml = React.FormEvent<HTMLFormElement>;
    const handleCloseData = () => setShowData(false);
    const handleClose2 = () => setShow2(false);
    const formRef = useRef<HTMLFormElement>(null);
    const [arrayMunicipio, setArrayMunicipio] = useState<Municipio[]>([]);
    //function to error the Token on the time, using when token is invalid or expired
    const [search, setSearch] = useState("");
    const [resumen, setResumen] = useState<any>({});
    const [objPact, setObjPact] = useState<Pacts>();

    const [sprogramming, setProgramming] = useState("");
    const [dateConciliation, setDateCommitment] = useState("");
    const [sattendance, setSattendance] = useState("");
    const [sattendanceBool, setSattendanceBool] = useState(false);

    let { id_concilia, name_creditor, ips_name, programming, date_conciliation, modality_con, balance, explanation, refund, id_creditor__type_creditor, id_creditor__document_creditor, modality_conciliation, id_ips__municipio_id__codigo_municipio, balance_conciliation } = useParams()
    let { id, date_pact, attendance, num_certificate, agreement, date_agreement, type_debt, value_pact, reconciliation_amount_erp, reconciliation_amount_ebp, gloss_acepted_ebp, gloss_corrected_erp, gloss_unresolved, value_reconciled, date_commitment_payment, value_payment, is_active, id_conciliation, doubleLink, object } =
        useForm<Pacts>(
            new Pacts(
                0,
                "",
                true,
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                "",
                0
            ) // Incluye `id_municipio` con un valor inicial
        );


    const cleanBox = (form: HTMLFormElement) => {
        form.reset();

        object.agreement = "";
        object.attendance = false;
        object.date_agreement = "";
        object.date_commitment_payment = "";
        object.value_payment = "";
        object.date_pact = "";
        object.gloss_acepted_ebp = "";
        object.gloss_corrected_erp = "";
        object.gloss_unresolved = "";
        object.num_certificate = "";
        object.reconciliation_amount_ebp = "";
        object.reconciliation_amount_erp = "";
        object.type_debt = "";
        object.value_pact = "";
        object.value_reconciled = "";

        (form.querySelector('[name="name_solicited"]') as HTMLInputElement).value =
            "";
        (form.querySelector('[name="role2"]') as HTMLInputElement).value = "";
        (form.querySelector('[name="number"]') as HTMLInputElement).value = "";
        (form.querySelector('[name="requirement"]') as HTMLInputElement).value = "";

        form.classList.remove("was-validated");
    };

    // Filtrar los datos según búsqueda
    const filteredIps = arrayPacts.filter((pacts) => {
        if (!search) return true; // si no hay búsqueda, no filtramos nada
        const term = search.toLowerCase().trim();
        return (
            pacts.num_certificate.toLowerCase().includes(term)
        );
    });
    const [sortedIps, setSortedIps] = useState(filteredIps);
    const handleTokenError = () => {
        navigate("/");
    };


    const getMunicipality = async () => {
        try {
            const urlGetMunc = ApiBack.MUNICIPIOS_LIST;
            const result = await ServicePrivate.requestGET(urlGetMunc);
            setArrayMunicipio(result);
        } catch (error) {
            console.error("Error fetching profesional:", error);
            setShow(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError();
            }
        }
    };

    const handleShowCreate = async () => {
        setShow2(true);
        getMunicipality();

    }

    const getPactConciliation = async () => {
        try {
            const url = ApiBack.VIEW_PACT_BY_CONCI + "?id_conciliation=" + id_concilia
            const results = await ServicePrivate.requestGET(url);
            console.log(results);

            if (results) {
                const payload = results.results || [];
                const resumen = results.resumen || {};
                setArrayPacts(payload);
                setResumen(resumen)
            } else {
                setLoading(true);
            }
        } catch (error) {
            console.error("Error fetching IPS:", error);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError();
            }
        }
    };

    const sendForm = async (fh: formaHtml) => {
        try {
            fh.preventDefault();
            setProcess(true);
            const form = fh.currentTarget;

            form.classList.add("was-validated");

            if (form.checkValidity() === false) {
                fh.preventDefault();
                fh.stopPropagation();
                setProcess(false);
                MessageToastify(
                    "error",
                    "Por favor, completa todos los campos requeridos.",
                    2000
                );
                return;
            }

            const formData = {
                id_conciliation: id_concilia,
                date_pact: date_pact,
                attendance: sattendance,
                num_certificate: num_certificate,
                agreement: agreement,
                date_agreement: date_agreement,
                type_debt: type_debt,
                value_pact: value_pact,
                reconciliation_amount_erp: reconciliation_amount_erp,
                reconciliation_amount_ebp: reconciliation_amount_ebp,
                gloss_acepted_ebp: gloss_acepted_ebp,
                gloss_corrected_erp: gloss_corrected_erp,
                gloss_unresolved: gloss_unresolved,
                value_reconciled: value_reconciled,
                date_commitment_payment: date_commitment_payment,
                value_payment: value_payment

            };

            const response = await ServicePrivate.requestPOST(
                ApiBack.CREATE_PACTS,
                formData
            );

            if (response.OK) {
                setProcess(false);
                MessageToastify(
                    "error",
                    "error al momento de crear el nuevo cliente.",
                    5000
                );
            } else {
                setProcess(false);
                handleClose2();
                getPactConciliation();
                MessageToastify("success", "El pacto se a creado con exito.", 2000);
                cleanBox(form);
            }
        } catch (error) {
            setProcess(false);

            MessageToastify(
                "error",
                "Error en el momento  crear el nuevo cliente.",
                7000
            );
        }
    };



    useEffect(() => {
        getPactConciliation();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (sattendance === "False") {
            setDateCommitment("1800-01-01");
        }
    }, [sattendance])

    const TYPE_DEBT_LABELS: Record<string, string> = {
        "1": "UPC Régimen Subsidiado",
        "2": "UPC Régimen Contributivo",
        "3": "UPC Régimen Contributivo",
        "4": "Presupuestos máximos",
        "5": "No UPC, ni presupuestos máximos",
        "6": "Población no afiliada",
        "7": "Salud Pública",
        "8": "Población Migrantes",
    };

    function parseAgreement(value: any) {
        if (value === true || value === "true" || value === "1" || value === 1) {
            return "1";        // verdadero
        }

        if (value === false || value === "false" || value === "0" || value === 0) {
            return "2";        // falso
        }

        return "3";            // no aplica
    }

    const getOnePact = async (id: number) => {
        try {
            const urlGetUser = ApiBack.VIEW_PACT_BY_ID + "?id=" + id;
            const result = await ServicePrivate.requestGET(urlGetUser);
            setObjPact(result[0]);
            console.log(objPact);

            setShowData(true);
        } catch (error) {
            console.error("Error fetching profesional:", error);
            setShow(false);
            const token = localStorage.getItem("access");
            if (token === null) {
                handleTokenError(); // Manejar el error de token
            }
        }
    };


    const downloadTXT = () => {
        if (!arrayPacts || arrayPacts.length === 0) {
            MessageToastify('error', 'No hay datos de conciliación para exportar.', 5000);
            return;
        }

        // Convertir cada registro en una línea con |
        const lines = arrayPacts.map(item => {
            const programmingText = programming === "true" ? "1" : "2";
            const attendanceText = attendance === true ? "1" : "2";
            const agreementText = parseAgreement(item.agreement);

            return [
                id_creditor__type_creditor,
                id_creditor__document_creditor,
                id_ips__municipio_id__codigo_municipio,
                programmingText,
                formatDate(date_conciliation),
                agreementText,
                item.num_certificate,
                attendanceText,
                formatDate(item.date_pact),
                item.type_debt,
                item.reconciliation_amount_erp,
                item.reconciliation_amount_ebp,
                refund,
                explanation,
                item.gloss_acepted_ebp,
                item.gloss_corrected_erp,
                item.gloss_unresolved,
                item.value_reconciled,
                formatDate(item.date_commitment_payment),
                item.value_payment,

            ].join("|");
        });

        // Unir líneas con salto de línea
        const textContent = lines.join("\n");

        // Crear un archivo descargable
        const blob = new Blob([textContent], { type: "text/plain" });
        const url = URL.createObjectURL(blob);

        // Crear link y descargar
        const link = document.createElement("a");
        link.href = url;
        link.download = "conciliaciones.txt";
        link.click();

        // limpiar memoria
        URL.revokeObjectURL(url);
    }

    return (
        <>
            <div>
                <div className="row">
                    <div className="col-lg-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-lg-6 col-sm-4">
                                        <h4 className="card-title fs-4">
                                            <i className="fa-solid fa-list"></i>&nbsp;Busqueda de pactos
                                        </h4>
                                    </div>
                                    <div className="col-lg-6 col-sm-4">
                                        <div className="d-flex justify-content-center justify-content-md-end py-2 p-md-0">
                                            <button
                                                className={
                                                    "badge fs-6 py-1 pe-2 text-success-emphasis bg-success-subtle border border-success-subtle rounded-pill"
                                                }
                                                type="button"
                                                onClick={() => handleShowCreate()}
                                                style={{ marginLeft: "10px" }}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;Crear
                                            </button>
                                            <button
                                                className={
                                                    "badge fs-6 py-1 pe-2 text-info-emphasis bg-info-subtle border border-info-subtle rounded-pill"
                                                }
                                                type="button"
                                                onClick={() => downloadTXT()}
                                                style={{ marginLeft: "10px" }}
                                            >
                                                <i className="fa-solid fa-file"></i>&nbsp;FT039
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="mb-4">
                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                            <h4 className="mb-1 fw-bold">Datos de la Conciliación</h4>
                                        </div>

                                        <Row className="g-2 mb-1">
                                            <Col md={12} lg={12}>
                                                <Card className=" border-start" >
                                                    <Card className="border-none ps-2">
                                                        <div className="row mt-1">
                                                            <div className="col-lg-4"><p className="mb-2 text-muted">Nombre Acreedor: <b className="fs-">{name_creditor}</b></p></div>
                                                            <div className="col-lg-4"><p className="mb-2 text-muted">IPS: <b className="fs-">{ips_name}</b></p></div>
                                                            <div className="col-lg-2"><p className="mb-2 text-muted">Modalidad: <b className="fs-"><b>
                                                                {modality_con === "1"
                                                                    ? "Presencial"
                                                                    : modality_con === "2"
                                                                        ? "Virtual"
                                                                        : modality_con === "3"
                                                                            ? "No aplica"
                                                                            : ""}
                                                            </b></b></p></div>
                                                            <div className="col-lg-2"><p className="mb-2 text-muted">Fecha de Conciliación: <b className="fs-">{formatDate(date_conciliation)}</b></p></div>
                                                        </div>
                                                    </Card>
                                                </Card>
                                            </Col>

                                        </Row>

                                        <Row className="g-2">
                                            <Col md={4}>
                                                <Card className="bg-success bg-opacity-10">
                                                    <Card.Body className="p-1">
                                                        <Card.Subtitle className="text-muted small mb-1">Saldo: <b className="fw-bolder">{formatCurrency(balance)}</b></Card.Subtitle>
                                                    </Card.Body>
                                                </Card>
                                            </Col>

                                            <Col md={4}>
                                                <Card className="bg-primary bg-opacity-10">
                                                    <Card.Body className="p-1">
                                                        <Card.Subtitle className="text-muted small mb-1">Glosa: <b className="fw-bolder">{formatCurrency(explanation)}</b></Card.Subtitle>
                                                    </Card.Body>
                                                </Card>
                                            </Col>

                                            <Col md={4}>
                                                <Card className="bg-danger bg-opacity-10">
                                                    <Card.Body className="p-1">
                                                        <Card.Subtitle className="text-muted small mb-1">Devolución: <b className="fw-bolder">{formatCurrency(refund)}</b></Card.Subtitle>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        </Row>
                                    </div>

                                </div>
                                <div className="row d-flex justify-center">
                                    <div className="col-lg-2 col-md-2">
                                        <p>
                                            Total de pactos:&nbsp;
                                            <b className="fw-bold">{resumen.total_ips}</b>
                                        </p>

                                    </div>
                                    <div className="col-lg-3 col-md-2">
                                        <p>
                                            Total de pactos el la busqueda:&nbsp;
                                            <b className="fw-bold">{resumen.total_ips}</b>
                                        </p>

                                    </div>
                                </div>

                                <div className="table-responsive rounded-table" style={{
                                    maxHeight: "70vh",
                                    overflowY: "auto",
                                    zIndex: 1020
                                }}>

                                    <table className="table table-striped table-sm table-hover table-sm">
                                        <thead className="table-dark " style={{ position: "sticky", top: 0, zIndex: 10 }}>
                                            <tr>
                                                <th style={{ width: "25%" }}>Fecha reunion</th>
                                                <th style={{ width: "25%" }}>Asistencia</th>
                                                <th style={{ width: "10%" }}>Número de acta</th>
                                                <th style={{ width: "15%" }}>Acuerdo</th>
                                                <th style={{ width: "15%" }}>Fecha de acuerdo</th>
                                                <th style={{ width: "18%" }}>Tipo deuda</th>
                                                <th style={{ width: "12%" }}>Valor pagado</th>
                                                {/* <th style={{ width: "12%" }}>Monto conciliar erp</th>
                                                <th style={{ width: "12%" }}>Monto conciliar ebp</th>
                                                <th style={{ width: "12%" }}>Glosa aceptada ebp</th>
                                                <th style={{ width: "12%" }}>Glosa subsanada erp</th>
                                                <th style={{ width: "12%" }}>Glosa no resuelta</th> */}
                                                <th style={{ width: "12%" }}>Valor conciliado</th>
                                                <th style={{ width: "12%" }}>Fecha compromiso</th>
                                                <th style={{ width: "12%" }}>Valor pagar</th>
                                                <th style={{ width: "12%" }}></th>
                                            </tr>
                                        </thead>
                                        <tbody className="table-group-divider ">
                                            {(sortedIps.length > 0 ? sortedIps : filteredIps).map((myCreditor, count) => (
                                                <tr key={count + 1}>
                                                    <td>{formatDate(myCreditor.date_pact)}</td>
                                                    <td>{myCreditor.attendance === true ? "Sí" : "No"}</td>
                                                    <td>{myCreditor.num_certificate}</td>
                                                    <td>{myCreditor.agreement ? "Sí" : "No"}</td>
                                                    <td>{formatDate(myCreditor.date_agreement)}</td>
                                                    <td>
                                                        {TYPE_DEBT_LABELS[myCreditor.type_debt] || "No definido"}
                                                    </td>
                                                    <td>{myCreditor.value_pact}</td>
                                                    <td>{myCreditor.value_reconciled}</td>
                                                    <td>{formatDate(myCreditor.date_commitment_payment)}</td>
                                                    <td>{myCreditor.value_payment}</td>
                                                    <td>
                                                        <button
                                                            className={`badge btn-mini rounded-pill border ${myCreditor.is_active
                                                                ? "text-info-emphasis bg-info-subtle border-info-subtle"
                                                                : "text-secondary bg-secondary-subtle border-secondary"
                                                                }`}
                                                            onClick={() => getOnePact(myCreditor.id)}
                                                            disabled={!myCreditor.is_active}
                                                        >
                                                            <i className="fa-solid fa-info"></i>
                                                        </button>
                                                        &nbsp;
                                                        <button
                                                            className={`badge btn-mini rounded-pill border ${myCreditor.is_active
                                                                ? "text-dark-emphasis bg-dark-subtle border-dark-subtle"
                                                                : "text-secondary bg-secondary-subtle border-secondary"
                                                                }`}
                                                            disabled={!myCreditor.is_active}
                                                        >
                                                            <i className="fa-solid fa-pen-to-square"></i>
                                                        </button>
                                                        &nbsp;
                                                        <button
                                                            className={`badge btn-mini rounded-pill border ${myCreditor.is_active
                                                                ? "text-primary-emphasis bg-primary-subtle border-primary-subtle"
                                                                : "text-secondary bg-secondary-subtle border-secondary"
                                                                }`}
                                                            onClick={() => {
                                                                navigate(`/home/list-pac-progress`);
                                                            }}
                                                            disabled={!myCreditor.is_active}
                                                        >
                                                            <i className="fa-solid fa-a"></i>
                                                        </button>
                                                        &nbsp;
                                                        <button
                                                            className={`badge btn-mini rounded-pill border ${myCreditor.is_active
                                                                ? "text-success-emphasis bg-success-subtle border-success-subtle"
                                                                : "text-secondary bg-secondary-subtle border-secondary"
                                                                }`}
                                                            onClick={() => {
                                                                navigate(`/home/list-pac-progress`);
                                                            }}
                                                            disabled={!myCreditor.is_active}
                                                        >
                                                            <i className="fa-solid fa-circle-exclamation"></i>
                                                        </button>

                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className="d-flex align-items-center justify-content-center m-3"></div>
                                </div>


                                <Modal
                                    show={showData}
                                    onHide={handleCloseData}
                                    backdrop="static"
                                    keyboard={false}
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered
                                    size="xl"
                                >
                                    <Modal.Header closeButton className="border-bottom-0 pb-2">
                                        <Modal.Title className="text-center fw-bold w-100" style={{ color: "#0f0f70" }}>
                                            Datos pacto
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body className="pt-1">
                                        <Card className="mt-0 border-0 shadow-none">
                                            <Card.Body className="">

                                                {/* Row 1: Fecha pacto y Asistencia */}
                                                <Card className="bg-primary bg-opacity-10 p-3">
                                                    <Row className="g-4">
                                                        <Col xs={12} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fs-6 fw-light mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-regular fa-id-card me-2"></i>Fecha pacto
                                                                </h6>
                                                                <p className="fw-semibold fs-5 text-dark mb-0">
                                                                    {formatDate(objPact?.date_pact)}
                                                                </p>
                                                            </div>
                                                        </Col>
                                                        <Col xs={12} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-solid fa-phone-volume me-2"></i>Fecha de acuerdo
                                                                </h6>
                                                                <p className="fw-semibold fs-5 text-dark mb-0">
                                                                    {formatDate(objPact?.date_agreement)}
                                                                </p>
                                                            </div>
                                                        </Col>
                                                        <Col xs={12} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-regular fa-envelope me-2"></i>Fecha compromiso
                                                                </h6>
                                                                <p className="text-uppercase fw-semibold fs-5 text-dark mb-0">
                                                                    {formatDate(objPact?.date_commitment_payment)}
                                                                </p>
                                                            </div>
                                                        </Col>
                                                        <Col xs={6} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fs-6 fw-light mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-solid fa-calendar me-2"></i>Asistencia
                                                                </h6>
                                                                <p className="fw-semibold fs-5 text-dark mb-0">
                                                                    {objPact?.attendance}
                                                                </p>
                                                            </div>
                                                        </Col>
                                                        <Col xs={6} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-regular fa-envelope me-2"></i>Número de acta
                                                                </h6>
                                                                <p className="fw-semibold fs-5 text-dark mb-0">
                                                                    {objPact?.num_certificate}
                                                                </p>
                                                            </div>
                                                        </Col>

                                                        <Col xs={6} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-regular fa-envelope me-2"></i>Acuerdo
                                                                </h6>
                                                                <p className="text-uppercase fw-semibold fs-5 text-dark mb-0">
                                                                    {objPact?.agreement}
                                                                </p>
                                                            </div>
                                                        </Col>

                                                        <Col xs={6} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-solid fa-phone-volume me-2"></i>Tipo de deuda
                                                                </h6>
                                                                <p className="fw-semibold fs-5 text-dark mb-0" style={{ whiteSpace: "nowrap" }}>
                                                                    {TYPE_DEBT_LABELS[objPact?.type_debt ?? ""] || "No definido"}
                                                                </p>
                                                            </div>
                                                        </Col>

                                                    </Row>
                                                </Card>
                                                <h4 className="mt-1 fw-bolder" style={{ color: "#0f0f70" }}>Información Financiera</h4>

                                                <Card className="bg-success bg-opacity-10 p-3 mt-1">
                                                    <Row className="g-4">
                                                        <Col xs={12} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-regular fa-envelope me-2"></i>Valor pagado
                                                                </h6>
                                                                <p className="text-uppercase fw-semibold fs-5 text-dark mb-0">
                                                                    {formatCurrency(objPact?.value_pact)}
                                                                </p>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-regular fa-envelope me-2"></i>Monto a conciliar erp
                                                                </h6>
                                                                <p className="text-uppercase fw-semibold fs-5 text-dark mb-0">
                                                                    {formatCurrency(objPact?.reconciliation_amount_erp)}
                                                                </p>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-regular fa-envelope me-2"></i>Monto a conciliar ebp
                                                                </h6>
                                                                <p className="text-uppercase fw-semibold fs-5 text-dark mb-0">
                                                                    {formatCurrency(objPact?.reconciliation_amount_ebp)}
                                                                </p>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-regular fa-envelope me-2"></i>Glosa aceptada ebp
                                                                </h6>
                                                                <p className="text-uppercase fw-semibold fs-5 text-dark mb-0">
                                                                    {formatCurrency(objPact?.gloss_acepted_ebp)}
                                                                </p>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-regular fa-envelope me-2"></i>Glosa subsanada erp
                                                                </h6>
                                                                <p className="text-uppercase fw-semibold fs-5 text-dark mb-0">
                                                                    {formatCurrency(objPact?.gloss_corrected_erp)}
                                                                </p>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-regular fa-envelope me-2"></i>Glosa no resulta
                                                                </h6>
                                                                <p className="text-uppercase fw-semibold fs-5 text-dark mb-0">
                                                                    {formatCurrency(objPact?.gloss_unresolved)}
                                                                </p>
                                                            </div>
                                                        </Col>

                                                        <Col xs={12} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-regular fa-envelope me-2"></i>Valor conciliado
                                                                </h6>
                                                                <p className="text-uppercase fw-semibold fs-5 text-dark mb-0">
                                                                    {formatCurrency(objPact?.value_reconciled)}
                                                                </p>
                                                            </div>
                                                        </Col>
                                                        <Col xs={12} md={6} lg={3}>
                                                            <div className="data-field">
                                                                <h6 className="text-uppercase fw-light fs-6 mb-2" style={{ color: "#0f0f70", letterSpacing: "1px" }}>
                                                                    <i className="fa-regular fa-envelope me-2"></i>Valor pagado
                                                                </h6>
                                                                <p className="text-uppercase fw-semibold fs-5 text-dark mb-0">
                                                                    {formatCurrency(objPact?.value_payment)}
                                                                </p>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Card.Body>
                                        </Card>
                                    </Modal.Body>
                                    <Modal.Footer className="border-top-0">
                                        <Button variant="danger" onClick={handleCloseData}>
                                            <i className="fa-solid fa-backward me-2"></i>
                                            Cerrar
                                        </Button>
                                    </Modal.Footer>
                                </Modal>


                                <Modal
                                    show={show2}
                                    onHide={handleClose2}
                                    backdrop="static"
                                    keyboard={false}
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered
                                    size="xl"
                                >
                                    <Modal.Header closeButton>
                                        <Modal.Title className="text-center fw-bold">
                                            <i className="fa-solid fa-folder-plus"></i>
                                            &nbsp;Formulario de creación
                                        </Modal.Title>
                                    </Modal.Header>
                                    <Form
                                        className="forms-sample"
                                        validated={process}
                                        onSubmit={sendForm}
                                        noValidate
                                        ref={formRef}
                                    >
                                        <Modal.Body>
                                            {/* Campo para nombre_ips */}
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <Form.Group controlId="date_pact" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="date_pact"
                                                        >
                                                            Fecha del pacto:
                                                        </Form.Label>

                                                        <Form.Control
                                                            required
                                                            type="date"
                                                            name="date_pact"
                                                            className="form-control"
                                                            id="date_pact"
                                                            placeholder="Escriba el tipo de acreedor"
                                                            value={date_pact}
                                                            onChange={(e) => {
                                                                doubleLink(e);
                                                                // setDateC(e.target.value);
                                                            }}
                                                            // readOnly={sattendance === "False"}
                                                            autoComplete="off"
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            La fecha del pacto es obligatorio.
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </div>

                                                <div className="col-lg-3">

                                                    <Form.Group controlId="sattendance" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="sattendance"
                                                        >
                                                            Asistencia:
                                                        </Form.Label>

                                                        <>
                                                            <Form.Select
                                                                required
                                                                id="sattendance"
                                                                name="sattendance"
                                                                value={sattendance}
                                                                onChange={(e) => {
                                                                    doubleLink(e);
                                                                    setSattendance(e.target.value);
                                                                    setSattendanceBool(e.target.value === "True");
                                                                }}
                                                            >
                                                                <option value="">Seleccione la asistencia</option>
                                                                <option value="True">Si</option>
                                                                <option value="False">No</option>

                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid">
                                                                La asistencia es obligatorio.
                                                            </Form.Control.Feedback>
                                                        </>
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-3">

                                                    <Form.Group controlId="value_pact" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="value_pact"
                                                        >
                                                            Valor pacto:
                                                        </Form.Label>

                                                        <>
                                                            <Form.Control
                                                                required
                                                                type="text"
                                                                id="value_pact"
                                                                name="value_pact"
                                                                placeholder="Escriba el valor del pacto"
                                                                value={
                                                                    value_pact
                                                                        ? `COP ${parseInt(value_pact).toLocaleString("es-CO")}`
                                                                        : ""
                                                                }
                                                                onChange={(e) => {
                                                                    const value = e.target.value;

                                                                    // Extraer solo números
                                                                    const onlyNumbers = value.replace(/\D/g, "");

                                                                    // Limitar longitud
                                                                    if (onlyNumbers.length <= 15) {
                                                                        const fakeEvent = {
                                                                            ...e,
                                                                            target: {
                                                                                ...e.target,
                                                                                value: onlyNumbers,
                                                                                name: e.target.name,
                                                                            },
                                                                        };

                                                                        doubleLink(fakeEvent);
                                                                    }
                                                                }}
                                                            ></Form.Control>
                                                            <Form.Control.Feedback type="invalid">
                                                                La asistencia es obligatorio.
                                                            </Form.Control.Feedback>
                                                        </>
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-3">
                                                    <Form.Group controlId="num_certificate" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="num_certificate"
                                                        >
                                                            Número de acta:
                                                        </Form.Label>
                                                        <Form.Control
                                                            required
                                                            type="text"
                                                            name="num_certificate"
                                                            className="form-control"
                                                            id="num_certificate"
                                                            placeholder="Escriba el número del acta"
                                                            value={num_certificate}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                // Permitir solo números y limitar a 20 caracteres
                                                                if (/^\d*$/.test(value) && value.length <= 20) {
                                                                    doubleLink(e); // Llama a tu función existente
                                                                }
                                                            }}
                                                            autoComplete="off"
                                                            maxLength={20} // Limita a 20 caracteres
                                                        />
                                                        <Form.Control.Feedback type="invalid">
                                                            El número de acta es obligatorio.
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-3">
                                                    <Form.Group controlId="agreement" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="agreement"
                                                        >
                                                            Acuerdo:
                                                        </Form.Label>
                                                        <Form.Select
                                                            required
                                                            id="agreement"
                                                            name="agreement"
                                                            value={agreement}
                                                            onChange={doubleLink}
                                                        >
                                                            <option value="">Seleccione el acuerdo</option>
                                                            <option value="True">Si</option>
                                                            <option value="False">No</option>

                                                        </Form.Select>
                                                    </Form.Group></div>
                                                <div className="col-lg-6">
                                                    <Form.Group controlId="date_agreement" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="date_agreement"
                                                        >
                                                            Fecha de acuerdo:
                                                        </Form.Label>
                                                        <Form.Control
                                                            required
                                                            type="date"
                                                            name="date_agreement"
                                                            className="form-control"
                                                            id="date_agreement"
                                                            placeholder="Escriba la glosa de la conciliación"
                                                            value={date_agreement}
                                                            onChange={(e) => {

                                                                doubleLink(e); // Llama a tu función existente

                                                            }}
                                                            autoComplete="off"
                                                            maxLength={20}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-6">
                                                    <Form.Group controlId="type_debt" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="type_debt"
                                                        >
                                                            Tipo de deuda:
                                                        </Form.Label>
                                                        <Form.Select
                                                            required
                                                            id="type_debt"
                                                            name="type_debt"
                                                            value={type_debt}
                                                            onChange={doubleLink}
                                                        >
                                                            <option value="">Seleccione la conciliacion</option>
                                                            <option value="1">UPC Régimen Subsidiado</option>
                                                            <option value="2">UPC Régimen Contributivo</option>
                                                            <option value="3">UPC Régimen Contributivo</option>
                                                            <option value="4">Presupuestos máximos</option>
                                                            <option value="5">No UPC, ni presupuestos máximos</option>
                                                            <option value="6">Población no afiliada</option>
                                                            <option value="7">Salud Pública</option>
                                                            <option value="8">Población Migrantes</option>

                                                        </Form.Select>
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-3"><Form.Group controlId="reconciliation_amount_erp" className="mb-3 w-100">
                                                    <Form.Label
                                                        className="fw-bold mb-2 mt-2"
                                                        htmlFor="reconciliation_amount_erp"
                                                    >
                                                        Monto a conciliar erp:
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="reconciliation_amount_erp"
                                                        className="form-control"
                                                        id="reconciliation_amount_erp"
                                                        placeholder="Escriba el monto a conciliar erp"
                                                        value={
                                                            sattendanceBool
                                                                ? `COP ${Number(reconciliation_amount_erp || 0).toLocaleString("es-CO")}`
                                                                : "0"
                                                        }
                                                        onChange={(e) => {
                                                            const value = e.target.value;

                                                            // Extraer solo números
                                                            const onlyNumbers = value.replace(/\D/g, "");

                                                            // Limitar longitud
                                                            if (onlyNumbers.length <= 15) {
                                                                const fakeEvent = {
                                                                    ...e,
                                                                    target: {
                                                                        ...e.target,
                                                                        value: onlyNumbers,
                                                                        name: e.target.name,
                                                                    },
                                                                };

                                                                doubleLink(fakeEvent);
                                                            }
                                                        }}
                                                        autoComplete="off"
                                                        maxLength={15}
                                                        disabled={!sattendanceBool}
                                                    />
                                                </Form.Group></div>
                                                <div className="col-lg-3">

                                                    <Form.Group controlId="reconciliation_amount_ebp" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="reconciliation_amount_ebp"
                                                        >
                                                            Monto a conciliar ebp:
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="reconciliation_amount_ebp"
                                                            className="form-control"
                                                            id="reconciliation_amount_ebp"
                                                            placeholder="Escriba el monto a conciliar ebp"
                                                            value={
                                                                sattendanceBool
                                                                    ? `COP ${Number(reconciliation_amount_ebp || 0).toLocaleString("es-CO")}`
                                                                    : "0"
                                                            }
                                                            onChange={(e) => {
                                                                const value = e.target.value;

                                                                // Extraer solo números
                                                                const onlyNumbers = value.replace(/\D/g, "");

                                                                // Limitar longitud
                                                                if (onlyNumbers.length <= 15) {
                                                                    const fakeEvent = {
                                                                        ...e,
                                                                        target: {
                                                                            ...e.target,
                                                                            value: onlyNumbers,
                                                                            name: e.target.name,
                                                                        },
                                                                    };

                                                                    doubleLink(fakeEvent);
                                                                }
                                                            }}
                                                            autoComplete="off"
                                                            maxLength={15}
                                                            disabled={!sattendanceBool}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-3">
                                                    <Form.Group controlId="gloss_acepted_ebp" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="gloss_acepted_ebp"
                                                        >
                                                            Glosa aceptada ebp:
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="gloss_acepted_ebp"
                                                            className="form-control"
                                                            id="gloss_acepted_ebp"
                                                            placeholder="Escriba la glosa aceptada ebp"
                                                            value={
                                                                sattendanceBool
                                                                    ? `COP ${Number(gloss_acepted_ebp || 0).toLocaleString("es-CO")}`
                                                                    : "0"
                                                            }
                                                            onChange={(e) => {
                                                                const value = e.target.value;

                                                                // Extraer solo números
                                                                const onlyNumbers = value.replace(/\D/g, "");

                                                                // Limitar longitud
                                                                if (onlyNumbers.length <= 15) {
                                                                    const fakeEvent = {
                                                                        ...e,
                                                                        target: {
                                                                            ...e.target,
                                                                            value: onlyNumbers,
                                                                            name: e.target.name,
                                                                        },
                                                                    };

                                                                    doubleLink(fakeEvent);
                                                                }
                                                            }}
                                                            autoComplete="off"
                                                            maxLength={15}
                                                            disabled={!sattendanceBool}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-3">
                                                    <Form.Group controlId="gloss_corrected_erp" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="gloss_corrected_erp"
                                                        >
                                                            Glosa subsanada erp:
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="gloss_corrected_erp"
                                                            className="form-control"
                                                            id="gloss_corrected_erp"
                                                            placeholder="Escriba la glosa subsanada erp"
                                                            value={
                                                                sattendanceBool
                                                                    ? `COP ${Number(gloss_corrected_erp || 0).toLocaleString("es-CO")}`
                                                                    : "0"
                                                            }
                                                            onChange={(e) => {
                                                                const value = e.target.value;

                                                                // Extraer solo números
                                                                const onlyNumbers = value.replace(/\D/g, "");

                                                                // Limitar longitud
                                                                if (onlyNumbers.length <= 15) {
                                                                    const fakeEvent = {
                                                                        ...e,
                                                                        target: {
                                                                            ...e.target,
                                                                            value: onlyNumbers,
                                                                            name: e.target.name,
                                                                        },
                                                                    };

                                                                    doubleLink(fakeEvent);
                                                                }
                                                            }}
                                                            autoComplete="off"
                                                            maxLength={15}
                                                            disabled={!sattendanceBool}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-3">
                                                    <Form.Group controlId="gloss_unresolved" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="gloss_unresolved"
                                                        >
                                                            Glosa no resuelta:
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="gloss_unresolved"
                                                            className="form-control"
                                                            id="gloss_unresolved"
                                                            placeholder="Escriba la glosa no resuelta"
                                                            value={
                                                                sattendanceBool
                                                                    ? `COP ${Number(gloss_unresolved || 0).toLocaleString("es-CO")}`
                                                                    : "0"
                                                            }
                                                            onChange={(e) => {
                                                                const value = e.target.value;

                                                                // Extraer solo números
                                                                const onlyNumbers = value.replace(/\D/g, "");

                                                                // Limitar longitud
                                                                if (onlyNumbers.length <= 15) {
                                                                    const fakeEvent = {
                                                                        ...e,
                                                                        target: {
                                                                            ...e.target,
                                                                            value: onlyNumbers,
                                                                            name: e.target.name,
                                                                        },
                                                                    };

                                                                    doubleLink(fakeEvent);
                                                                }
                                                            }}
                                                            autoComplete="off"
                                                            maxLength={15}
                                                            disabled={!sattendanceBool}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-3">
                                                    <Form.Group controlId="value_reconciled" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="value_reconciled"
                                                        >
                                                            Valor conciliado:
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="value_reconciled"
                                                            className="form-control"
                                                            id="value_reconciled"
                                                            placeholder="Escriba el valor conciliado"
                                                            value={
                                                                sattendanceBool
                                                                    ? `COP ${Number(value_reconciled || 0).toLocaleString("es-CO")}`
                                                                    : "0"
                                                            }
                                                            onChange={(e) => {
                                                                const value = e.target.value;

                                                                // Extraer solo números
                                                                const onlyNumbers = value.replace(/\D/g, "");

                                                                // Limitar longitud
                                                                if (onlyNumbers.length <= 15) {
                                                                    const fakeEvent = {
                                                                        ...e,
                                                                        target: {
                                                                            ...e.target,
                                                                            value: onlyNumbers,
                                                                            name: e.target.name,
                                                                        },
                                                                    };

                                                                    doubleLink(fakeEvent);
                                                                }
                                                            }}
                                                            autoComplete="off"
                                                            maxLength={15}
                                                            disabled={!sattendanceBool}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-6">

                                                    <Form.Group controlId="date_commitment_payment" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="date_commitment_payment"
                                                        >
                                                            Fecha compromiso:
                                                        </Form.Label>
                                                        {sattendance === "False" ? (
                                                            <p className="text-secondary fst-italic">
                                                                No tiene programación, por lo tanto la fecha de conciliación se establece en 01-01-1800
                                                            </p>
                                                        ) : (
                                                            <>
                                                                <Form.Control
                                                                    required
                                                                    type="date"
                                                                    name="date_commitment_payment"
                                                                    className="form-control"
                                                                    id="date_commitment_payment"
                                                                    placeholder="Escriba el tipo de acreedor"
                                                                    value={date_commitment_payment}
                                                                    onChange={(e) => {
                                                                        doubleLink(e);
                                                                        setDateCommitment(e.target.value);
                                                                    }}
                                                                    readOnly={sprogramming === "False"}
                                                                    autoComplete="off"
                                                                />
                                                                <Form.Control.Feedback type="invalid">
                                                                    El tipo de acreedor es obligatorio.
                                                                </Form.Control.Feedback>
                                                            </>)}
                                                    </Form.Group>
                                                </div>
                                                <div className="col-lg-6">

                                                    <Form.Group controlId="value_payment" className="mb-3 w-100">
                                                        <Form.Label
                                                            className="fw-bold mb-2 mt-2"
                                                            htmlFor="value_payment"
                                                        >
                                                            Valor a pagar:
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            name="value_payment"
                                                            className="form-control"
                                                            id="value_payment"
                                                            placeholder="Escriba el valor a pagar"
                                                            value={
                                                                sattendanceBool
                                                                    ? `COP ${Number(value_payment || 0).toLocaleString("es-CO")}`
                                                                    : "0"
                                                            }
                                                            onChange={(e) => {
                                                                const value = e.target.value;

                                                                // Extraer solo números
                                                                const onlyNumbers = value.replace(/\D/g, "");

                                                                // Limitar longitud
                                                                if (onlyNumbers.length <= 15) {
                                                                    const fakeEvent = {
                                                                        ...e,
                                                                        target: {
                                                                            ...e.target,
                                                                            value: onlyNumbers,
                                                                            name: e.target.name,
                                                                        },
                                                                    };

                                                                    doubleLink(fakeEvent);
                                                                }
                                                            }}
                                                            autoComplete="off"
                                                            maxLength={15}
                                                            disabled={!sattendanceBool}
                                                        />
                                                    </Form.Group>
                                                </div>
                                            </div>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button variant="danger" onClick={handleClose2}>
                                                <i className="fa-solid fa-backward"></i>&nbsp;Cancelar
                                            </Button>
                                            <Button
                                                variant="success"
                                                type="submit"
                                                onClick={() => { }}
                                            >
                                                <i className="fa-solid fa-plus"></i>&nbsp;Guardar
                                            </Button>
                                        </Modal.Footer>
                                    </Form>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </div >
        </>
    );
};
